module.exports = __webpack_public_path__ + "static/media/mylinhlac.01ef1cb3.jpeg";